<template>
  <div>
    <nav-bar></nav-bar>
    <div id="aboutUs"
         class="container-fluid has-action-bar bg-music">

      <div class="container">
        <div class="row align-items-center justify-content-center" style="min-height: 600px">
          <div class="col-lg-7 col-12">
            <h3 class="font20px d-block text-align secondary-text">{{ $getText("ABOUT-US-PAGE-TITLE") }}</h3>
            <p class="gray-text font14px d-block pt-3 text-align">{{ $getText("ABOUT-US-PAGE-DESC1") }}</p>

            <p class="gray-text font14px pt-3 d-lg-block d-none text-align">
              {{ $getText("ABOUT-US-PAGE-DESC2") }}
              <br><br>
              {{ $getText("ABOUT-US-PAGE-DESC3") }}
            </p>
          </div>
          <div class="col-lg-5">
            <img src="../assets/img/aboutus-copy-01.png" alt="aboutus" class="img-fluid">
          </div>
        </div>
      </div>

    </div>

    <footer-pages></footer-pages>
  </div>
</template>

<script>

import NavBar from "@/components/NavBar";

import FooterPages from "@/components/FooterPages";

export default {
  name: "AboutUs",
  metaInfo: {
    title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-درباره ما'
  },
  components: {FooterPages, NavBar},
  data: () => ({
    title: "درباره ما",
    isokia: [],
  }),
  mounted() {
    this.isokia = this.$getisokia();
    this.$setCssFiles();
  },
  getImgUrl(pic) {
    return require("../assets/img/" + pic);
  }

}
</script>

<style scoped>

</style>
